<template>
  <div class="pt-1 pb-2 pr-1 pl-1">
    <div class="no-gutters mt-1 ml-3 mr-3">
      <div class="row">
        <div class="col-12">
          <div class="parameter-box">
            <h5 v-b-popover.hover.bottom="latitude + ' ' + longitude">{{ position }}</h5>
            <div class="parameter-name">Current position</div>
          </div>
        </div>
      </div>
      <!--div class="row">
        <div class="col">
          <div class="parameter-box">
            <h4 v-if="speed_over_ground !== null">
              <a href="#" class="parameter-link" @click="selectParameter(1, 106)" title="Show speed over ground in chart and map">{{ showDigits(speed_over_ground, 1) }}</a> <small>kn</small>
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Speed over ground</div>
          </div>
        </div>
        <div class="col">
          <div class="parameter-box">
            <h4 v-if="course_over_ground !== null">
              <a href="#" class="parameter-link" @click="selectParameter(1, 100)" title="Show course over ground in chart and map">{{ showDigits(course_over_ground, 1) }}</a><small>°</small>
              <font-awesome-icon :icon="['fas', 'location-arrow']" size="xs" class="text-info ml-2" :style="{ transform: rotateArrowCOG(course_over_ground) }" />
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Course over ground</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="parameter-box">
            <h4 v-if="boat_speed !== null">
              <a href="#" class="parameter-link" @click="selectParameter(1, 166)" title="Show boat speed in chart and map">{{ showDigits(boat_speed, 1) }}</a> <small>kn</small>
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Boat speed</div>
          </div>
        </div>
        <div class="col">
          <div class="parameter-box">
            <h4 v-if="heading !== null">
              <a href="#" class="parameter-link" @click="selectParameter(1, 3)" title="Show heading in chart and map">{{ showDigits(heading, 1) }}</a><small>°</small>
              <font-awesome-icon :icon="['fas', 'location-arrow']" size="xs" class="text-info ml-2" :style="{ transform: rotateArrowHeading(heading) }" />
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Heading</div>
          </div>
        </div>
      </div-->
      <div class="row">
        <div class="col d-inline-flex">
          <img :src="platform_icon" style="height: 35px; margin-top: 10px;" class="ml-2">
          <div style="font-size: 15px; line-height: 18px;" class="ml-2 pt-2">Team<br><span style="font-size: 18px;"><strong>{{ platform_name }}</strong></span></div>
        </div>
        <div class="col">
          <div class="parameter-box">
            <h4 v-if="true_wind_speed !== null">
              <a href="#" class="parameter-link" @click="selectParameter(1, 204)" title="Show true wind speed in chart and map">{{ showDigits(true_wind_speed, 1) }}</a> <small>kn</small>
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">True wind speed</div>
          </div>
        </div>
        <!--div class="col">
          <div class="parameter-box">
            <h4 v-if="heel_angle !== null">
              <a href="#" class="parameter-link" @click="selectParameter(1, 10)" title="Show angle of heel in chart and map">{{ showDigits(heel_angle, 1) }}</a><small>°</small>
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Angle of heel</div>
          </div>
        </div-->
      </div>
      <!--div class="row">
        <div class="col">
          <span class="ml-2 dashboard-group-header">Wind:</span>
        </div>
        <div class="col">
          <hr class="mr-2 dashboard-group-header-hr">
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="parameter-box">
            <h4 v-if="apparent_wind_angle !== null">
              <a href="#" class="parameter-link" @click="selectParameter(1, 201)" title="Show apparent wind angle in chart and map">{{ showDigits(apparent_wind_angle, 1) }}</a><small>°</small>
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Apparent wind angle</div>
          </div>
        </div>
        <div class="col">
          <div class="parameter-box">
            <h4 v-if="apparent_wind_speed !== null">
              <a href="#" class="parameter-link" @click="selectParameter(1, 202)" title="Show apparent wind speed in chart and map">{{ showDigits(apparent_wind_speed, 1) }}</a> <small>kn</small>
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Apparent wind speed</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="parameter-box">
            <h4 v-if="true_wind_angle !== null">
              <a href="#" class="parameter-link" @click="selectParameter(1, 203)" title="Show true wind angle in chart and map">{{ showDigits(true_wind_angle, 1) }}</a><small>°</small>
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">True wind angle</div>
          </div>
        </div>
        <div class="col">
          <div class="parameter-box">
            <h4 v-if="true_wind_speed !== null">
              <a href="#" class="parameter-link" @click="selectParameter(1, 204)" title="Show true wind speed in chart and map">{{ showDigits(true_wind_speed, 1) }}</a> <small>kn</small>
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">True wind speed</div>
          </div>
        </div>
      </div-->
      <div class="row">
        <div class="col">
          <span class="ml-2 dashboard-group-header">Scientific data:</span>
        </div>
        <div class="col">
          <hr class="mr-2 dashboard-group-header-hr">
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="parameter-box">
            <h4 v-if="air_temperature !== null">
              <a href="#" class="parameter-link" @click="selectParameter(101, 3)" title="Show air temperature in chart and map">{{ showDigits(air_temperature, 1) }}</a> <small>°C</small>
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Air temperature</div>
          </div>
        </div>
        <div class="col">
          <div class="parameter-box">
            <h4 v-if="air_pressure !== null">
              <a href="#" class="parameter-link" @click="selectParameter(101, 1)" title="Show air pressure in chart and map">{{ showDigits(air_pressure, 0) }}</a> <small>hPa</small>
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Air pressure</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="parameter-box">
            <h4 v-if="sea_temperature !== null">
              <a href="#" class="parameter-link" @click="selectParameter(102, 1)" title="Show sea temperature in chart and map">{{ showDigits(sea_temperature, 1) }}</a> <small>°C</small>
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Sea temperature</div>
          </div>
        </div>
        <div class="col">
          <div class="parameter-box">
            <h4 v-if="salinity !== null">
              <a href="#" class="parameter-link" @click="selectParameter(102, 2)" title="Show salinity in chart and map">{{ showDigits(salinity, 1) }}</a> <small>PSU</small>
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Salinity</div>
          </div>
        </div>
      </div>
      <div class="row" v-if="co2 !== null || conductivity !== null">
        <div class="col">
          <div class="parameter-box">
            <h4 v-if="conductivity !== null">
              <a href="#" class="parameter-link" @click="selectParameter(102, 3)" title="Show conductivity in chart and map">{{ showDigits(conductivity, 1) }}</a> <small>mS/cm</small>
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Conductivity</div>
          </div>
        </div>
        <div class="col">
          <div class="parameter-box">
            <h4 v-if="co2 !== null">
              <a href="#" class="parameter-link" @click="selectParameter(102, 6)" title="Show CO2 in chart and map">{{ showDigits(co2, 1) }}</a> <small>ppm</small>
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Carbon dioxide (CO<sub>2</sub>)</div>
          </div>
        </div>
      </div>
      <div class="row" v-if="o2 !== null || h2o !== null">
        <div class="col">
          <div class="parameter-box">
            <h4 v-if="o2 !== null">
              <a href="#" class="parameter-link" @click="selectParameter(102, 4)" title="Show O2 in chart and map">{{ showDigits(o2, 1) }}</a> <small>&#xb5;M</small>
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Oxygen (O<sub>2</sub>)</div>
          </div>
        </div>
        <div class="col">
          <div class="parameter-box">
            <h4 v-if="h2o !== null">
              <a href="#" class="parameter-link" @click="selectParameter(102, 15)" title="Show H2O in chart and map">{{ showDigits(h2o, 1) }}</a> <small>ppt</small>
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Dihydrogen oxide (H<sub>2</sub>O)</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import Helpers from '@/mixins/helpers'

/**
 * Constant defining the time delay allowed for data to be displayed
 * @type {number} [ms]
 */
// const UPDATE_TIMEOUT_MS = 60 * 60 * 2000

export default {
  name: 'ShipOceanRaceStatusWidget',
  mixins: [
    Helpers
  ],
  data: function () {
    return {}
  },
  props: ['platformId'],
  methods: {
    ...mapMutations(['select_parameter']),
    rotateArrowHeading: function (heading) {
      return 'rotate(' + Number(Number(heading) - 45) + 'deg)'
    },
    rotateArrowCOG: function (heading) {
      return 'rotate(' + Number(Number(heading) - 45) + 'deg)'
    },
    selectParameter: function (entityId, parameterId) {
      this.select_parameter([this.platformId, entityId, parameterId])
    }
  },
  computed: {
    ...mapState(['platforms']),
    ...mapGetters(['currentUpdate', 'lastUpdate', 'parameter']),
    platform_name () {
      return this.platforms[this.platformId].description
    },
    platform_icon () {
      return this.platforms[this.platformId].icon_url
    },
    recentUpdate () {
      return (entityId, parameterId) => {
        const update = this.currentUpdate(this.platformId, entityId, parameterId)
        // const parameter = this.parameter(this.platformId, entityId, parameterId)
        // return ((update.length !== 0) && (this.updateAgeValid(update, parameter, UPDATE_TIMEOUT_MS))) ? Number(update[1]) : null
        return (update.length !== 0) ? Number(update[1]) : null
      }
    },
    position () {
      const position = this.getCoordinatesNautical(this.roundDigits(this.latitude, 5),
        this.roundDigits(this.longitude, 5))
      return position.lat + ' ' + position.lng
    },
    latitude () {
      // Latitude will always be visible
      const update = this.currentUpdate(this.platformId, 1, 1)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    longitude () {
      // Longitude will always be visible
      const update = this.currentUpdate(this.platformId, 1, 2)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    heading () {
      return this.recentUpdate(1, 3)
    },
    course_over_ground () {
      return this.recentUpdate(1, 100)
    },
    boat_speed () {
      return this.recentUpdate(1, 166)
    },
    speed_over_ground () {
      return this.recentUpdate(1, 106)
    },
    heel_angle () {
      return this.recentUpdate(1, 10)
    },
    apparent_wind_angle () {
      return this.recentUpdate(1, 201)
    },
    apparent_wind_speed () {
      return this.recentUpdate(1, 202)
    },
    true_wind_angle () {
      return this.recentUpdate(1, 203)
    },
    true_wind_speed () {
      return this.recentUpdate(1, 204)
    },
    air_temperature () {
      return this.recentUpdate(101, 3)
    },
    air_pressure () {
      return this.recentUpdate(101, 1)
    },
    sea_temperature () {
      return this.recentUpdate(102, 1)
    },
    salinity () {
      return this.recentUpdate(102, 2)
    },
    conductivity () {
      return this.recentUpdate(102, 3)
    },
    co2 () {
      return this.recentUpdate(102, 6)
    },
    o2 () {
      return this.recentUpdate(102, 4)
    },
    h2o () {
      return this.recentUpdate(102, 15)
    }
  }
}
</script>

<style lang="scss" scoped>

.parameter-box {
  padding: 10px 10px 5px 10px;
}
.parameter-box h4 {
  margin-bottom: 2px;
}
.parameter-box h5 {
  margin-bottom: 2px;
}
.parameter-name {
  font-size: 11px;
  color: #6c757d;
}
.parameter-link {
  color: #212529;
  text-decoration: none;
}
.state-box {
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  vertical-align: bottom;
  border-radius: 2px;
  padding: 5px 2px 5px 2px;
}
.state-ok {
  background-color: #82E0AA;
  color: #186A3B;
}
.state-danger {
  background-color: #F1948A;
  color: #78281F;
}
.no-gutters {
  margin-right: 10px;
  margin-left: 10px;
  .col,
  [class*="col-"] {
    padding-right: 2px;
    padding-left: 2px;
  }
}
.dashboard-group-header {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.25);
  font-weight: bold;
}
.dashboard-group-header-hr {
  margin-block-end: 0;
}
</style>
